import API from "../../..";
import { fullUrl } from '../../../utile/utile.api';

/* パスワード再設定（パスワードを忘れた場合に使用。認証不要） */

export type PasswordResetRequestParam = {
  /** ○	パスワードリセットトークン */
  token: string,
  /** ○	新しいパスワード */
  password: string,
  /** ○	確認用パスワード */
  password_confirmation: string,
}

const path = '/reset';

const reset = (url: string) => () => {
  const full = fullUrl(url, path);
  return ({
    put: (param: PasswordResetRequestParam) => API.con
      .put<PasswordResetRequestParam, {}>({ url: full, data: param }),
  })
}

export default reset;
